import { MessageSquare } from 'lucide-react'

interface Props {
  isOpen: boolean
  onClick: () => void
}

export function ChatToggleButton({ isOpen, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className={`fixed bottom-6 right-6 z-[55] w-14 h-14 rounded-full bg-primary-600 text-white shadow-lg hover:bg-primary-700 hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center group ${
        isOpen ? 'opacity-0 pointer-events-none scale-90' : 'opacity-100'
      }`}
      aria-label="Open AI assistant"
    >
      <MessageSquare className="w-6 h-6" />
      <span className="absolute -top-10 right-0 px-2 py-1 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        AI Assistant <kbd className="ml-1 px-1 py-0.5 bg-gray-700 rounded text-[10px]">⌘K</kbd>
      </span>
    </button>
  )
}
